import { render, staticRenderFns } from "./SidebarElement.vue?vue&type=template&id=61412103&"
import script from "./SidebarElement.vue?vue&type=script&lang=js&"
export * from "./SidebarElement.vue?vue&type=script&lang=js&"
import style0 from "./SidebarElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports